import ForecastActions, { forecastActionTypes } from '@Actions/application/forecastActions';
import TrackerActions from '@Actions/trackerActions';
import {
  put, takeEvery, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import ForecastServices from '@Services/application/forecastServices';

/**
 *
 * @param action
 * @returns {Generator<*, void, *>}
 * @private
 */
function* _createForecast(action) {
  const { formData, callback } = action;
  try {
    yield put(ForecastActions.createForecastLoading(true));
    const forecast = yield ForecastServices.createForecast(formData);
    if (forecast?.inserted_data?.[0]) {
      yield put(ForecastActions.getForecastByIdSuccess(forecast?.inserted_data?.[0]));
      if (callback) {
        callback(forecast?.inserted_data?.[0]);
      }
    }
    yield put(ForecastActions.createForecastLoading(false));
  } catch (error) {
    yield put(ForecastActions.createForecastLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(forecastActionTypes.CREATE_FORECAST.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* createForecast() {
  yield takeEvery(forecastActionTypes.CREATE_FORECAST.REQUEST, _createForecast);
}

function* _startForecast(action) {
  const { payload, callback } = action;
  try {
    yield put(ForecastActions.startForecastLoading(true));
    const forecast = yield ForecastServices.startForecast(payload);
    yield put(ForecastActions.getForecastById({ forecast_id: payload?.forecast_id }, () => {}));
    if (callback) {
      callback();
    }
    yield put(ForecastActions.startForecastLoading(false));
  } catch (error) {
    yield put(ForecastActions.startForecastLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(forecastActionTypes.START_FORECAST.ERROR, error));
  }
}

function* startForecast() {
  yield takeEvery(forecastActionTypes.START_FORECAST.REQUEST, _startForecast);
}

/**
 *
 * @param action
 * @returns {Generator<*, void, *>}
 * @private
 */
function* _getForecastById(action) {
  const { payload, callback } = action;
  try {
    yield put(ForecastActions.getForecastByIdLoading(true));
    const forecast = yield ForecastServices.getForecastById(payload?.forecast_id);
    yield put(ForecastActions.getForecastByIdSuccess(forecast?.data?.[0]));
    yield put(ForecastActions.getForecastByIdLoading(false));
  } catch (error) {
    yield put(ForecastActions.getForecastByIdLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(forecastActionTypes.GET_FORECAST_BY_ID.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getForecastById() {
  yield takeEvery(forecastActionTypes.GET_FORECAST_BY_ID.REQUEST, _getForecastById);
}

/**
 *
 * @param action
 * @returns {Generator<*, void, *>}
 * @private
 */
function* _getForecastList(action) {
  const { payload, callback } = action;
  try {
    yield put(ForecastActions.getForecastListLoading(true));
    const forecasts = yield ForecastServices.getForecasts(payload?.status, payload?.orgId, payload?.page, payload?.limit, payload?.searchKeyword);
    yield put(ForecastActions.getForecastListSuccess(forecasts));
    yield put(ForecastActions.getForecastListLoading(false));
  } catch (error) {
    yield put(ForecastActions.getForecastListLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(forecastActionTypes.GET_FORECAST_LIST.ERROR, error));
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getForecastList() {
  yield takeEvery(forecastActionTypes.GET_FORECAST_LIST.REQUEST, _getForecastList);
}

function* _getForecastResults(action) {
  const { payload, callback } = action;
  try {
    yield put(ForecastActions.getForecastResultsLoading(true));
    const forecast = yield ForecastServices.getForecastResults(payload?.forecastId, payload?.modelName, payload?.store, payload?.item, payload?.channel);
    yield put(ForecastActions.getForecastResultsSuccess(forecast?.forecast_details?.[0]));
    if (callback) {
      callback();
    }
    yield put(ForecastActions.getForecastResultsLoading(false));
  } catch (error) {
    yield put(ForecastActions.getForecastResultsLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(forecastActionTypes.GET_FORECAST_LIST.ERROR, error));
  }
}

function* getForecastResults() {
  yield takeEvery(forecastActionTypes.GET_FORECAST_RESULTS.REQUEST, _getForecastResults);
}

function* _downloadForecast(action) {
  const { payload, callback } = action;
  try {
    yield put(ForecastActions.downloadForecastLoading(true));
    const forecast = yield ForecastServices.downloadForecast(payload?.forecastId, payload?.modelName, payload?.store, payload?.item, payload?.channel);
    if (callback) {
      callback();
    }
    if (forecast) {
      const link = document.createElement('a');
      link.target = '_blank';
      link.download = `FORECAST_${payload?.forecastId}`;
      link.href = URL.createObjectURL(
        new Blob([forecast], { type: forecast.type }),
      );
      link.click();
    }
    yield put(ForecastActions.downloadForecastLoading(false));
  } catch (error) {
    yield put(ForecastActions.downloadForecastLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(forecastActionTypes.DOWNLOAD_FORECAST.ERROR, error));
  }
}

function* downloadForecast() {
  yield takeEvery(forecastActionTypes.DOWNLOAD_FORECAST.REQUEST, _downloadForecast);
}

/**
 *
 */
export default function* forecastSaga() {
  yield all([
    createForecast(),
    startForecast(),
    getForecastList(),
    getForecastById(),
    downloadForecast(),
    getForecastResults(),
  ]);
}
